import { Model } from 'app/model/backendmodel';
import { ModelConstants, IntegrationRuntime } from 'shell-models-lib';
import { IntegrationRuntimeAdapters } from 'app/integrationruntime/integrationruntime.adapter';
import { irTypesConst } from 'app/integrationruntime/integrationruntime.constants';
import { ManagedIntegrationRuntime } from 'app/model/integrationRuntime/managed.integrationRuntime';

export const defaultVNetName = 'default';

export function getManagedVnetResource(resourceId: string, vnetName?: string): Model.ManagedVirtualNetworkResource {
    return {
        name: vnetName || defaultVNetName,
        type: `${resourceId}/${ModelConstants.managedVirtualNetwork}s`
    };
}

export function isManagedVnetIr(ir: IntegrationRuntime): boolean {
    const irType = IntegrationRuntimeAdapters.GetIRTypeFromLocalModel(ir);
    return ir instanceof ManagedIntegrationRuntime
        && (irType === irTypesConst.Azure || irType === irTypesConst.ManagedVNet);
}
